import React from "react";
import { Spin } from "antd";
import Icon from "@mdi/react";
import { mdiChevronDown, mdiChevronLeft, mdiClose } from "@mdi/js";
import { currencyDisplay } from "../../../../utils/helpers";

const ringFormat = (value: number) => {
  const text = currencyDisplay("MYR", value);
  return Number.isInteger(Number(value)) ? text.replace(/\.00$/, "") : text;
};

/** Back chevron + 4 progress segments (selection, travellers, partner, payment) - Figma 10102:250006. */
export function MobileProgressHeader({ step, onBack }: { step: 1 | 2 | 3 | 4; onBack: () => void }) {
  return (
    <header className="gt-m-header">
      <button type="button" onClick={onBack} aria-label="Back"><Icon path={mdiChevronLeft} size="28px" /></button>
      <div className="gt-m-progress" role="progressbar" aria-valuemin={1} aria-valuemax={4} aria-valuenow={step}>
        {[1, 2, 3, 4].map((value) => <span key={value} className={value <= step ? "is-done" : ""} />)}
      </div>
    </header>
  );
}

/** Sheet-style header: title on the left, close on the right (Edit Selection, Passenger, e-Invoice). */
export function MobileTitleHeader({ title, onClose }: { title: string; onClose: () => void }) {
  return (
    <header className="gt-m-header is-title">
      <h1>{title}</h1>
      <button type="button" onClick={onClose} aria-label="Close"><Icon path={mdiClose} size="24px" /></button>
    </header>
  );
}

interface FooterProps {
  total: number | undefined;
  loading?: boolean;
  onShowBreakdown: () => void;
  /** Selection and traveller pages: "Total" above the amount, full-width button below. Others: amount left, button right. */
  stacked?: boolean;
  children: React.ReactNode;
}

export function MobileFooter({ total, loading, onShowBreakdown, stacked, children }: FooterProps) {
  const amount = (
    <button type="button" className="gt-m-footer__amount" onClick={onShowBreakdown} aria-label="View price summary">
      {loading ? <Spin size="small" /> : <strong>{total === undefined ? "–" : ringFormat(total)}</strong>}
      <Icon path={mdiChevronDown} size="20px" />
    </button>
  );
  return (
    <footer className={`gt-m-footer ${stacked ? "is-stacked" : ""}`}>
      {stacked ? (
        <>
          <span className="gt-m-footer__label">Total</span>
          {amount}
          <div className="gt-m-footer__cta">{children}</div>
        </>
      ) : (
        <>
          <div>
            {amount}
            <small>(incl. taxes & fees)</small>
          </div>
          <div className="gt-m-footer__cta">{children}</div>
        </>
      )}
    </footer>
  );
}
